import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const state = {
	isAllow: false,
	isLang: '',
	cartNumber: parseInt(localStorage.getItem('cart_number')) || 0,
	Account:'',
	uid:'',
}

const getters = {
	getAccount: (state) => state.Account,
	getUid: (state) => state.uid,
}

const mutations = {
	SET_newLang: (state, isLang) => {
		state.isLang = isLang
		localStorage.setItem('newLang', isLang)
	},
	SET_CART_NUMBER: (state, cartNumber) => {
		localStorage.setItem('cart_number', cartNumber)
		state.cartNumber = localStorage.getItem('cart_number')
		console.log(state.cartNumber, 'dd')
	},
	updateAccount(state, Account) {
		state.Account = Account;
	},
	updateUid(state, uid) {
		state.uid = uid;
	},
	clearAccount(state){
	  state.Account = ''
	  state.uid = ''
	},
	// SET_EXCHANGE_RATE: (state, exchangeRate) => {
	// 	localStorage.setItem('exchangeRate', exchangeRate)
	// 	state.exchangeRate = localStorage.getItem('exchangeRate')
	// 	console.log(state.exchangeRate, 'exchangeRate4765')
	// },
}
const actions = {}
const plugins = [
	createPersistedState({
		key: "vuex",
		reducer(vuex) {
			return vuex;
		},
	}),
];
export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	modules: {},
	plugins,
})
